import React from 'react';
import { BoxPanel } from '../../../../components/BoxPanel/BoxPanel';

export const waitingForProcessing = (title: string): React.ReactNode => {
  return (
    <div className="px-2">
      <BoxPanel
        icon="pending"
        title={title}
        description={
          'This module is under processing or may not necessitate this step.'
        }
      />
    </div>
  );
};

export const moduleNotFound = (title: string): React.ReactNode => {
  return (
    <div className="px-2">
      <BoxPanel
        icon="unFinished"
        title={title}
        description={'This module is unfinished.'}
      />
    </div>
  );
};
